import clsx from "clsx";
import { useShallow } from "zustand/react/shallow";

import {
  IAuthStepEnum,
  useAuthStore,
} from "@templates/authManagement/authStore";
import { EmailVerificationView } from "@templates/authManagement/emailVerificationView";
import { ForgetPasswordView } from "@templates/authManagement/forgetPasswordView";
import { LoginView } from "@templates/authManagement/loginView";
import { ResetPasswordView } from "@templates/authManagement/resetPasswordView";
import { StudentVerificationView } from "@templates/authManagement/studentVerificationView";

import classes from "./styles.module.scss";

export function AuthContent() {
  const step = useAuthStore(useShallow((state) => state.step));

  return (
    <div className={clsx(classes.authContent)}>
      {step === IAuthStepEnum.LOGIN && <LoginView />}
      {step === IAuthStepEnum.RESET_PASSWORD && <ForgetPasswordView />}
      {step === IAuthStepEnum.CHECK_RESET_PASSWORD_VERIFICATION && (
        <EmailVerificationView />
      )}
      {step === IAuthStepEnum.SET_NEW_PASSWORD && <ResetPasswordView />}
      {step === IAuthStepEnum.CHECK_SIGN_UP_EMAIL_VERIFICATION && (
        <StudentVerificationView />
      )}
    </div>
  );
}
